import { act } from "react";
import * as actionTypes from "../actionTypes";

const initialState = {
  loading: false,
  loadingManageProductLanguage: false,
  getProductLanguage: null,
  menuList: null,
  menuListError: null,
  success: null,
  error: null, 
  successManageProductLanguage: null,
  errorManageProductLanguage: null, 
  
  addonsList: null,
  addonsListError: null,
};
export const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_MENU_LIST_START:
      return { ...state, loading: true, error:null, menuListError: null, menuList: null };
    case actionTypes.GET_MENU_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        menuListError: null,
        menuList: action.payload,
      };
    };
    case actionTypes.GET_MENU_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        menuListError: action.payload,
        error:action.payload,
        menuList: null,
      };
    case actionTypes.ADD_MENU_START:
      return { ...state, loading: true, error: null, success: null };
    case actionTypes.ADD_MENU_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: action.payload.message,
        error: null,
      };
    };
    case actionTypes.ADD_MENU_FAILURE:
      console.log("action.payload in the add menu Failure", action.payload);
      return {
        ...state,
        loading: false,
        success: null,
        error:action.payload
      };
    case actionTypes.UPDATE_MENU_START:
      return { ...state, loading: true, error: null, success: null };
    case actionTypes.UPDATE_MENU_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: action.payload.message,
        error: null,
      };
    };
    case actionTypes.UPDATE_MENU_FAILURE:
      return {
        ...state,
        loading: false,
        success: null,
        error:action.payload
      };
    case actionTypes.ADD_PRODUCT_LANGUAGE_START:
      return { ...state, loadingManageProductLanguage: true, successManageProductLanguage: null, errorManageProductLanguage: null };
    case actionTypes.ADD_PRODUCT_LANGUAGE_SUCCESS:
      return {
        ...state,
        loadingManageProductLanguage: false,
        successManageProductLanguage: action.payload.message,
        errorManageProductLanguage: null
      };
    case actionTypes.ADD_PRODUCT_LANGUAGE_FAILURE:
      return {
        ...state,
        loadingManageProductLanguage: false,
        errorManageProductLanguage: action.payload,   
        successManageProductLanguage: null,
      };
    case actionTypes.GET_PRODUCT_LANGUAGE_START:
      return { ...state, loadingManageProductLanguage: true, successManageProductLanguage: null, errorManageProductLanguage: null, getProductLanguage: null };
    case actionTypes.GET_PRODUCT_LANGUAGE_SUCCESS:
      return {
        ...state,
        loadingManageProductLanguage: false,
        errorManageProductLanguage: null,
        getProductLanguage: action.payload
      };
    case actionTypes.GET_PRODUCT_LANGUAGE_FAILURE:
      return {
        ...state,
        loadingManageProductLanguage: false,
        errorManageProductLanguage: action.payload,   
        getProductLanguage: null
      };
    case actionTypes.UPDATE_PRODUCT_LANGUAGE_START:
      return { ...state, loadingManageProductLanguage: true, successManageProductLanguage: null, errorManageProductLanguage: null };
    case actionTypes.UPDATE_PRODUCT_LANGUAGE_SUCCESS:
      return {
        ...state,
        loadingManageProductLanguage: false,
        successManageProductLanguage: action.payload.message,
        errorManageProductLanguage: null
      };
    case actionTypes.UPDATE_PRODUCT_LANGUAGE_FAILURE:
      return {
        ...state,
        loadingManageProductLanguage: false,
        errorManageProductLanguage: action.payload,   
        successManageProductLanguage: null,
      };
 
    case actionTypes.MESSAGE_HANDLER:
      return {
        ...state,
        loading: false,
        loadingManageProductLanguage: false,
        menuListError: action.payload,
        error: action.payload,
        success: action.payload,
        errorManageProductLanguage: action.payload,
        successManageProductLanguage: action.payload,
      };
    case actionTypes.GET_ADDONS_LIST_START:
      return { ...state, loading: true, error:null, addonsListError: null, addonsList: null };
    case actionTypes.GET_ADDONS_LIST_SUCCESS: {
      
      return {
        ...state,
        loading: false,
        addonsListError: null,
        addonsList: action.payload,
      };
    };
    case actionTypes.GET_ADDONS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        addonsListError: action.payload,
        error:action.payload,
        addonsList: null,
      };
    default:
      return { ...state };
  }
};
